import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconLayoutBottom"><Path d="M17.25 3.75C18.9069 3.75 20.25 5.09315 20.25 6.75V13.25C20.25 14.9069 18.9069 16.25 17.25 16.25L6.75 16.25C5.09315 16.25 3.75 14.9069 3.75 13.25V6.75C3.75 5.09315 5.09315 3.75 6.75 3.75L17.25 3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M20.25 20.25H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconLayoutBottom;
